export const version: string = __APP_VERSION__;
